import { useFirebaseAuth } from "./use-firebase-auth";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { clearNavigationAndFilterState } from "@/lib/authUtils";

export function useAuth() {
  const firebaseAuth = useFirebaseAuth();
  const queryClient = useQueryClient();
  
  // Check if currently impersonating
  const { data: impersonationStatus } = useQuery({
    queryKey: ["/api/auth/impersonation-status"],
    retry: false,
    enabled: !!firebaseAuth.user,
  });

  const logout = async () => {
    await firebaseAuth.signOut();
  };

  const stopImpersonation = async () => {
    try {
      const response = await fetch('/api/developer/stop-impersonation', {
        method: 'POST',
        credentials: 'include',
      });
      
      if (response.ok) {
        const data = await response.json();
        queryClient.clear();
        clearNavigationAndFilterState();
        // Use dynamic redirect from server response (supports nested impersonation)
        const redirectTo = data.redirectTo || '/developer-dashboard';
        window.location.href = redirectTo;
      }
    } catch (error) {
      console.error('Error stopping impersonation:', error);
    }
  };

  const login = async (username: string, password: string) => {
    // Firebase doesn't support username/password login
    // This is legacy code that can be removed
    console.warn('Username/password login is not supported with Firebase auth');
  };

  return {
    user: firebaseAuth.user,
    isLoading: firebaseAuth.isLoading,
    isAuthenticated: firebaseAuth.isAuthenticated,
    isImpersonating: (impersonationStatus as any)?.isImpersonating || false,
    isDevImpersonation: (impersonationStatus as any)?.isDevImpersonation || false,
    impersonationStackDepth: (impersonationStatus as any)?.stackDepth || 0,
    impersonationStack: ((impersonationStatus as any)?.stack || []) as { firstName: string; lastName: string; role: string }[],
    logout,
    stopImpersonation,
    login,
  };
}